<a
  class="festival-item {{ disabled ? 'disabled' : '' }}"
  [href]="festivalEdition.url ? festivalEdition.url : null"
  target="_blank"
>
  <h3 class="festival-item-subtitle">{{ festivalEdition.festival.name }}</h3>
  <div *ngIf="festivalEdition.festival.place?.city?.name" class="festival-item-place-wrapper">
    <fa-icon [icon]="mapIcon" size="lg"></fa-icon>
    <span class="festival-item-place-name">{{ festivalEdition.festival.place?.city?.name }}</span>
  </div>
  <!-- date string in the format from  -->
  <div class="festival-item-duration-wrapper">
    <span class="festival-item-from" i18n="@@movie.from" data-translate="movie.from">From</span>
    <span class="festival-item-duration">{{ ' ' + festivalEditionDuration }}</span>
  </div>
</a>
